import { nanoid } from 'nanoid';
import { isUndefined } from '../common/utils';
export function ParseOptions(options, rowGap, itemHeight, noUniqueIds) {
    return options
        .sort((a, b) => (b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 1))
        .filter(opt => (!isUndefined(opt.visible) ? opt.visible : true))
        .map((option, index) => ({
        id: !noUniqueIds ? nanoid() : option.id,
        ...option,
        selected: !isUndefined(option.selected) ? option.selected : false,
        top: index > 0 ? index * (itemHeight + rowGap) + rowGap : rowGap,
        value: option.value || option.name,
        visible: true,
    }));
}
